import { useEffect, useState } from 'react'

export function useConfetti(initialState = false, duration = 7000) {
  const [confetti, setConfetti] = useState(initialState)
  useEffect(() => {
    if (confetti) {
      setTimeout(() => setConfetti(false), duration)
    }
  }, [confetti, duration])
  return { confetti, showConfetti: () => setConfetti(true) }
}
